module.exports = __webpack_public_path__ + "img/3ne.5a3dce13.svg";